// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_ARCHIVE_CAMPAIGNS_PAGE_TITLE = "Dni so zna\u010dkou";
export const SEO_TITLE_FORUM_CAMPAIGN = "Dni so zna\u010dkou";
